const { DateTime } = require("luxon");

const money = (data: number) => {
  const dollars = data / 100;
  return dollars.toLocaleString("en-US", {style:"currency", currency:"USD"})
}

const dateFormat = (date: string) => {
  return DateTime.fromSQL(date).toFormat('ff')
  // return DateTime.fromSQL(date).toLocaleString(DateTime.DATETIME_FULL);
}

const cloudinaryTransform = (thumbnailURL, mods) => {
  if (thumbnailURL.includes('res.cloudinary.com') && !thumbnailURL.includes('c_fill')) {
    const extractedPublicId = thumbnailURL.split('upload/');
    return `${extractedPublicId[0]}upload/${mods.join('/')}/${extractedPublicId[1]}`;
  }
  return thumbnailURL;
};

const scrollToRef = (ref: any) => window.scrollTo(0, ref.current.offsetTop)

// Export each function
export {
  money,
  dateFormat,
  scrollToRef,
  cloudinaryTransform
};
